import React from 'react';

import SupportRequestPresenter from '../../../../../../presenters/SupportRequestPresenter';
import Group from '../../../../../../components/Group';
import Row from '../../../../../../components/Row';
import Column from '../../../../../../components/Column';
import Value from '../../../../../../components/Value';

const TransactionInfo = (props) => {
  const { request } = props;

  return (
    <Group title="Missing Transaction Info">
      <Row>
        <Column>
          <Value attr="transactionDate" title="Transaction Date">
            {SupportRequestPresenter.date(request)}
          </Value>
        </Column>
        <Column>
          <Value attr="transactionAmount" title="Transaction Amount">
            {SupportRequestPresenter.amountReadable(request)}
          </Value>
        </Column>
        <Column>
          <Value attr="transactionStore" title="Store Name">
            {SupportRequestPresenter.storeName(request)}
          </Value>
        </Column>
        <Column>
          <Value attr="institutionName" title="Institution Name">
            {SupportRequestPresenter.institutionName(request)}
          </Value>
        </Column>
      </Row>
    </Group>
  );
};

export default TransactionInfo;

TransactionInfo.propTypes = {
  request: SupportRequestPresenter.shape().isRequired,
};
